const PARAMETER_CONTROLS_CONTAINER_HTML_ID = 'visualization-parameter-controls';
const PARAMETER_CONTROLS_CONTAINER_HEIGHT = 31;

export { PARAMETER_CONTROLS_CONTAINER_HEIGHT, PARAMETER_CONTROLS_CONTAINER_HTML_ID };
